import { Bound, GetMealResponseData, GetOrderResponseData, Traveler, Type1 } from 'src/sdk-servicing';
import { AirportI18n } from '../master/airport_i18n_all';
import { MFucntionIneligibleReason } from '../master/m_function_ineligble_reason';
import { MListData } from '../master/m_listdata';
import { MPreOrderMealFlight } from '../master/m_preorder_meal_flight';
import { MSpecialMeal } from '../master/m_special_meal';
import { SeatReservationStatus } from '../servicing-seatmap/seat-reservation-status';
import { ChargeableLounge, FirstBaggage, MealInformation, MyBooking } from './mybooking.interface';

export interface LHParams {
  partnerId: string;
  ENC: string;
  Language: string;
  Country: string;
}

export interface LangSwitch {
  code?: string;
  label?: string;
}

export interface ApplicableServiceAreaState {
  isShowSeats?: boolean;
}

export interface ListDataMapping {
  pnr?: GetOrderResponseData;
  myBookingModel?: MyBooking;
  seatFlightInforList?: Array<Type1>;
  seatPassengerInforList?: Array<Traveler>;
  firstBaggage?: FirstBaggage;
  mealInformation?: MealInformation;
  chargeableLounge?: ChargeableLounge;
  seatReservationStatus?: SeatReservationStatus;
  myCarValetDomestic?: boolean;
  myCarValetInternational?: boolean;
}

export interface MybookingServiceState {
  pnr?: GetOrderResponseData;
  firstBaggage?: FirstBaggage;
  mealInformation?: MealInformation;
  chargeableLounge?: ChargeableLounge;
  seatReservationStatus?: SeatReservationStatus;
  flights?: Array<Type1>;
  flightsByUN?: Array<Type1>;
  travelersByINF?: Array<Traveler>;
  // 事前座席指定セグメント情報リスト
  seatFlightInforList?: Array<Type1>;
  // 事前座席指定搭乗者情報リスト
  seatPassengerInforList?: Array<Traveler>;
  // 事前追加手荷物バウンド情報リスト
  firstBaggageBoundInforList?: Array<Bound>;
  // 事前追加手荷物搭乗者情報リスト
  firstBaggagePassengerInforList?: Array<Traveler>;
  // コールセンター申込手荷物セグメント情報リスト
  callCenterBaggageFlightInforList?: Array<Type1>;
  // コールセンター申込手荷物搭乗者情報リスト
  callCenterBaggagePassengerInforList?: Array<Traveler>;
  // ラウンジセグメント情報リスト
  loungeFlightInforList?: Array<Type1>;
  // ラウンジ搭乗者情報リスト
  loungePassengerInforList?: Array<Traveler>;
  // 機内食セグメント情報リスト
  mealFlightInforList?: Array<Type1>;
  // 機内食搭乗者情報リスト
  mealPassengerInforList?: Array<Traveler>;
  // ペットらくのりセグメント情報リスト
  petRakunoriFlightInforList?: Array<Type1>;
  // ペットらくのり搭乗者情報リスト
  petRakunoriPassengerInforList?: Array<Traveler>;
  // マイカーバレーセグメント情報
  myCarValetFlightInforList?: Array<Type1>;
  // マイカーバレー搭乗者情報
  myCarValetPassengerInforList?: Array<Traveler>;
  // ジュニアパイロットセグメント情報
  juniorPilotFlightInforList?: Array<Type1>;
  // ジュニアパイロット搭乗者情報
  juniorPilotPassengerInforList?: Array<Traveler>;
  // アテンドセグメント情報リスト
  attendFlightInforList?: Array<Type1>;
  // アテンド搭乗者情報リスト
  attendPassengerInforList?: Array<Traveler>;
  // 配慮系サポート情報セグメントリ
  supportFlightInforList?: Array<Type1>;
  // 配慮系サポート搭乗者情報リスト
  supportPassengerInforList?: Array<Traveler>;
}

export interface MasterDataS01P033 {
  listData?: Array<MListData>;
  airportI18nAll?: AirportI18n;
  mSpecialMeal?: Array<MSpecialMeal>;
  mPreOrderMealFlight?: Array<MPreOrderMealFlight>;
  mFucntionIneligibleReason?: MFucntionIneligibleReason;
}
export interface ShowHideServiceState {
  isExistLounge?: boolean;
  isExistMyCarValetInfor?: boolean;
  isExistInFlightMeal?: boolean;
  isExistCallCenterApplicationBaggageService?: boolean;
  isExistFirstBaggageService?: boolean;
  isExistSeatService?: boolean;
  isExistLoungeService?: boolean;
  isExistMyCarValetService?: boolean;
  isExistMealService?: boolean;
  isExistPetService?: boolean;
  isExistJuniorPilotService?: boolean;
  isExistSupportService?: boolean;
  myCarValetDomestic?: boolean;
  myCarValetInternational?: boolean;
}
export const INITIAL_MYBOOKING_SERVICE_MASTER_DATA: MasterDataS01P033 = {
  listData: [],
  airportI18nAll: undefined,
  mSpecialMeal: [],
  mPreOrderMealFlight: [],
  mFucntionIneligibleReason: undefined,
};

export interface PaidLoungeSsrMapStore {
  [key: string]: LoungeSsrMapStore;
}
export interface LoungeSsrMapStore {
  [key: string]: number;
}
export interface PaidLoungeSsrMapPnr {
  [key: string]: LoungeSsrMapPnr;
}
export interface LoungeSsrMapPnr {
  [key: string]: string;
}
export interface MealSsrMap {
  [key: string]: number;
}

export interface MealErrors {
  // セグメントID
  flightId?: string;
  // SSRコード
  ssrCode?: string;
  // 在庫数
  quota?: number;
  // 便名
  flightNumber?: string;
  // 出発地
  departure?: string;
  // 到着地
  arrival?: string;
}
export const INITIAL_MYBOOKING_SERVICE_STATE: MybookingServiceState = {
  pnr: {},
  firstBaggage: {},
  mealInformation: {},
  chargeableLounge: {},
  seatReservationStatus: {},
  flights: [],
  flightsByUN: [],
  travelersByINF: [],
  seatFlightInforList: [],

  seatPassengerInforList: [],

  firstBaggageBoundInforList: [],

  firstBaggagePassengerInforList: [],

  callCenterBaggageFlightInforList: [],

  callCenterBaggagePassengerInforList: [],

  loungeFlightInforList: [],

  loungePassengerInforList: [],

  mealFlightInforList: [],

  mealPassengerInforList: [],

  petRakunoriFlightInforList: [],

  petRakunoriPassengerInforList: [],

  myCarValetFlightInforList: [],

  myCarValetPassengerInforList: [],

  juniorPilotFlightInforList: [],

  juniorPilotPassengerInforList: [],

  attendFlightInforList: [],

  attendPassengerInforList: [],

  supportPassengerInforList: [],
};

export const INITIAL_SHOW_HIDE_SERVICE_STATE: ShowHideServiceState = {
  isExistLounge: false,
  isExistMyCarValetInfor: false,
  isExistInFlightMeal: false,
  isExistMyCarValetService: false,
  isExistPetService: false,
  isExistCallCenterApplicationBaggageService: false,
  isExistFirstBaggageService: false,
  isExistSeatService: false,
  isExistLoungeService: false,
  isExistMealService: false,
  isExistJuniorPilotService: false,
  isExistSupportService: false,
  myCarValetDomestic: false,
  myCarValetInternational: false,
};
